// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { shipToSelectorStyles } from "@werner/Overrides/Components/ShipToSelector";
import { color } from "@werner/XDL/Utilities";
import { css } from "styled-components";

shipToSelectorStyles.wrapper = {
    css: css`
        width: 100%;
        position: relative;
    `,
};

shipToSelectorStyles.clearIconStyles = {
    size: 14,
    css: css`
        position: absolute;
        top: 28px;
        right: 50px;
        &:hover {
            color: ${color("primary")};
        }
    `,
};

shipToSelectorStyles.shipToSelectorDynamicDropdown = {
    cssOverrides: {
        selectedText: css`
            &&&&&& {
                padding-right: 50px;
            }
        `,
    },
};
